<template>
<div class="album py-5 bg-light">
    <div class="container">

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col" v-for="(gc,index) in gcards" :key="index">
          <GalleryCard :key='index' :gc_title="gc.gc_title" :gc_subtitle="gc.gc_subtitle" :gc_image="gc.gc_image"></GalleryCard>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/cZLR8DZGRiA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><text x="50%" y="50%" fill="#eceeef" dy=".3em">冰糖燕窝</text>
            <div class="card-body">
              <p class="card-text">三鱼大厨展示御燕玺礼 之 冰糖燕窝</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon v-for="i in [1,2,3,4,5]" :key="i" name="star" class="c-red" /></button>
                  <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon name="good-job-o" /></button>
                </div>
                <van-icon name="like-o" class="c-red" />
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/b8Gcm4h8DB0" title="和牛的烹饪" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <div class="card-body">
              <p class="card-text">三鱼大厨展示和牛料理</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon v-for="i in [1,2,3,4,5]" :key="i" name="star" class="c-red" /></button>
                  <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon name="good-job-o" /></button>
                </div>
                <van-icon name="like-o" class="c-red" />
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/hmxux4tITYk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <div class="card-body">
              <p class="card-text">央视健康专家谈燕窝</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon v-for="i in [1,2,3,4,5]" :key="i" name="star" class="c-red" /></button>
                  <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon name="good-job-o" /></button>
                </div>
                <van-icon name="like-o" class="c-red" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
  import { onMounted } from 'vue'
  import GalleryCard from '@/views/GalleryCard'
  //import $ from 'jquery'
  export default {
    name: 'Gallery',
    components: {GalleryCard},
    emits: ['viewLoaded'],
    setup(props,ctx) {
      const gcards = [
        {
          gc_title: '御燕玺礼',
          gc_subtitle: '只做敢给家人吃的好燕窝',
          gc_image: require('../assets/gallery/1.jpg')
        },
        {
          gc_title: '蓝天白云下的厂房',
          gc_subtitle: '亚洲燕窝行业新生代最诚信品牌之一',
          gc_image: require('../assets/gallery/2.jpg')
        },
        {
          gc_title: '燕窝基地',
          gc_subtitle: '严格的工作制度是生产高质量燕窝的保证',
          gc_image: require('../assets/gallery/3.jpg')
        },
        {
          gc_title: '国际权威认证',
          gc_subtitle: 'HACCP | GMP | MESTI 认证证书，只认有缘人',
          gc_image: require('../assets/gallery/4.jpg')
        },
        {
          gc_title: '部长站台',
          gc_subtitle: '十年磨一剑的工匠精神赢得政要的垂倾',
          gc_image: require('../assets/gallery/5.jpg')
        },
        {
          gc_title: '国礼荣誉',
          gc_subtitle: '马来西亚国家副主席 国际贸易工业部部长与御燕玺礼',
          gc_image: require('../assets/gallery/6.jpg')
        },
        {
          gc_title: '品牌专卖',
          gc_subtitle: '御燕玺礼品牌专卖店',
          gc_image: require('../assets/gallery/7.jpg')
        },
        {
          gc_title: '御燕玺礼',
          gc_subtitle: '御燕玺礼精品礼盒',
          gc_image: require('../assets/gallery/8.jpg')
        },
      ]
        onMounted(() =>{
            console.log('Gallery mounted')
            ctx.emit('viewLoaded','gallery')
            
        })

        return {
          gcards
        }
    }
  };
</script>
<style lang="scss" scoped>
  nav {
    margin-top: 0px;
    margin-bottom: 1px;
    padding-top: 2px;
    padding-bottom: 5px;
    background: url(../assets/navbk.png) no-repeat center center; 
    background-size: 100% 100%;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #d88d00;
      }
    }
    .mobile-title {
      margin-top: 10px;
    }
    @media only screen and (min-width: 1200px) {
      .mobile-title {display:none;}
    }
  }

</style>